var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36204 10.0002C5.10004 10.0002 4.83904 9.89825 4.64304 9.69525L0.78004 5.69525C0.40204 5.30225 0.40704 4.67925 0.79304 4.29325L4.79304 0.29325C5.18304 -0.09775 5.81604 -0.09775 6.20704 0.29325C6.59704 0.68425 6.59704 1.31625 6.20704 1.70725L2.90204 5.01225L6.08104 8.30525C6.46504 8.70325 6.45404 9.33625 6.05704 9.71925C5.86204 9.90725 5.61204 10.0002 5.36204 10.0002Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevLeft);
export default __webpack_public_path__ + "static/media/chev-left.af1bd49d78e58f6edd8d8afc6e19eff1.svg";
export { ForwardRef as ReactComponent };